import { useEffect, useState } from 'react'
import { fetchSegmentView, type Period } from '../landing'
import { AREA_COLOR, AREA_LABEL, AREA_ORDER, AREA_UNIT, areaFromCategory, type Area } from '../segments'
import { PackagesTable } from './PackagesTable'

// B4 / meeting 25/8 — pack-size tables as PER-AREA blocks: one pack-size table per product
// area the supplier has (everything counted in CU), each with its own brand + SKU
// drill. Which areas to show comes from the segment view (the categories with own volume).
export function AreaPackages({ period }: { period: Period | null }) {
  const [areas, setAreas] = useState<Area[] | null>(null)
  const [error, setError] = useState(false)
  const [attempt, setAttempt] = useState(0)

  useEffect(() => {
    if (!period) return
    let cancelled = false
    setAreas(null)
    setError(false)
    fetchSegmentView(period.value)
      .then((cats) => {
        if (cancelled) return
        const present = new Set(
          cats.map((c) => areaFromCategory(c.category)).filter((a): a is Area => a !== null),
        )
        setAreas(AREA_ORDER.filter((a) => present.has(a)))
      })
      .catch(() => !cancelled && setError(true))
    return () => {
      cancelled = true
    }
  }, [period?.value, attempt])

  if (!period) return null
  if (error) return <div className="catalog-empty" role="alert">Could not load package categories. <button onClick={() => setAttempt((n) => n + 1)}>Try again</button></div>
  if (!areas) return <div className="catalog-empty">Loading…</div>
  if (!areas.length) return <div className="catalog-empty">No packages for this supplier.</div>

  return (
    <>
      {areas.map((area) => (
        <section key={area} style={{ marginBottom: 24, borderLeft: `3px solid ${AREA_COLOR[area]}`, paddingLeft: 14 }}>
          <div style={{ display: 'flex', alignItems: 'baseline', gap: 10, margin: '4px 0 10px' }}>
            <h2 style={{ fontSize: 18, fontWeight: 700, color: AREA_COLOR[area], margin: 0 }}>
              {AREA_LABEL[area]}
            </h2>
            <span
              style={{
                fontSize: 11,
                color: '#fff',
                background: AREA_COLOR[area],
                padding: '2px 8px',
                borderRadius: 999,
              }}
            >
              {AREA_UNIT[area]}
            </span>
          </div>
          <PackagesTable period={period} area={area} />
        </section>
      ))}
    </>
  )
}
